<template>
<div>
  <div>
    <vs-card noShadow ref="filterCard" :title="$t('salary_survey')" color="blue" class="user-list-filters mb-8">
      <vs-row>
          <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">{{
                $t('client')|capitalize
                }}</label>
          <v-select
                  v-model="selectClient"
                  :options="clients"
                  :reduce="(client) => client.ClientId"
                  class="w-full"
                  label="ShortName"
                  @input="onChange()"
              />
            
          </vs-col>
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">{{
                $t('time_period')|capitalize
                }}</label>
          <v-select
                  v-model="time_period"
                  :options="time_periods"
                  class="w-full"
                  @input="onChange()"
              />
            
          </vs-col>
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="pr-1 mt-4">
            <label class="text-sm opacity-75 px-1">{{
                $t('zone')|capitalize
                }}</label>
          <v-select
                  multiple
                  v-model="zone_period"
                  :options="zone_periods"
                  class="w-full"
                  @input="onChange()"
              />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="pr-1 mt-4">
            <br>
            <vs-button :disabled="list.length == 0" color="success" type="filled" class="w-full" @click="this.export">{{$t('export')}} </vs-button>
          </vs-col>
      </vs-row>
    </vs-card>
    <vs-card id="salary-survey-loading" class="vs-con-loading__container">
      <salary-survey-table 
        :data="list"
        />
    </vs-card>
  </div>
</div>
</template>

<script>
import salary_survey from '@/http/requests/salary_survey'
import SalarySurveyTable from './components/SalarySurveyTable.vue'
import client from '@/http/requests/client'
import vSelect from 'vue-select'
import {URL_CUSTOM_REPORT} from '@/urls.js'
import loading from '@/mixins/Loading'

export default {
  components: {
      vSelect,
      SalarySurveyTable
  },
  data: () => ({
      time_period : null,
      zone_period : null,
      selectClient : "Select Client",
      clientFilter: [],
      time_periods : [],
      zone_periods : [],
      list: [],
      clients: [],
      loading: {
        data: false,
      },
      params:{
          type:"Starting",
          zone:["NaN"],
          client:null
      }
  }),
  methods: {
    export() {
        let zone = this.zone_period.toString()
        console.log('conaa',this.zone_period)
        if(this.zone_period.toString() === ''  || this.zone_period===null){
          zone = "N/A"
        }
        let request = `salary-survey/0?client_id=${this.selectClient}&type=${this.time_period}&zona=${zone}`
        let new_url = URL_CUSTOM_REPORT + request
        //console.log(new_url)
        window.open(new_url)
    },
    getOptions() {
      client.list().then((res) => {
        this.clients = res.data.clients
      })
      salary_survey
        .getOptions()
        .then((res) => {
            this.zone_period = res.data.zones[0].zone
            res.data.zones.forEach((zones) => {
                this.zone_periods.push(zones.zone)
            })
            this.time_period = res.data.options[0].TYPE_DATA
            res.data.options.forEach((option) => {
                this.time_periods.push(option.TYPE_DATA)
            })
            //this.getList(this.params)
            
        })
        .catch((err) => {
          console.log("bug")
        })
        
    },
    getList(data) {
      this.openLoading('salary-survey-loading')
      salary_survey
        .getList(data)
        .then((res) => {
          this.list = Object.values(res.data.data.original.data)
          this.closeLoading('salary-survey-loading')
        })
        .catch((err) => {
          console.log("bug")
          this.closeLoading('salary-survey-loading')
        })
    } ,
    onChange() {
      
      
      if(this.time_period != null && this.selectClient != "Select Client"){
        this.params.zone = this.zone_period
        if(this.zone_period.length === 0){
          this.params.zone = "all"
        }
        this.params.client = this.selectClient
        this.params.type = this.time_period
        this.getList(this.params)
      }else{
        this.$vs.notify({
             color: 'warning',
             title: 'Alert',
             text: 'Seleccione Cliente y Periodo'
           })
      }
    },
  },
  mounted() {
      this.getOptions()
  },
  mixins: [loading]
}
</script>

<style></style>
